/* @flow */
import React, { useContext } from "react";
import Button from "nx-components/Button";
import connect from "nexia_mobile/flux_like/store/connect";
import Page from "nexia_mobile/components/Page";
import ScrollableArea from "nexia_mobile/components/Scrollable/ScrollableArea";
import OverlayLinearProgress from "nexia_mobile/components/OverlayLinearProgress";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

type Props = {
  appBar: React.Node,
  showDeviceAdd: () => void,
  backgroundLoading: boolean,
  title: string,
};

const NoDevicesPageCommercial = (props: Props) => {
  const { appBar, showDeviceAdd, backgroundLoading, title } = props;
  const languageContext = useContext(UserLanguageContext);
  const language =
    languageContext.localeSet.nexia_mobile.NoDevicesPageCommercial;
  return (
    <Page name="NoDevicesPageCommercial" fullyLoaded>
      {appBar}
      {backgroundLoading && <OverlayLinearProgress indeterminate />}
      <ScrollableArea>
        <div
          style={{
            padding: "0.75em",
          }}
        >
          <p>
            {languageContext.template(language.noStatsEnrolledYetTemplate, {
              title,
            })}
          </p>
          <p>
            {languageContext.template(language.tapEnrollCallToActionTemplate, {
              title,
            })}
          </p>
          <div style={{ textAlign: "center" }}>
            <Button theme="important" onTap={showDeviceAdd}>
              {language.enrollNewDevicebutton}
            </Button>
          </div>
        </div>
      </ScrollableArea>
    </Page>
  );
};

export default connect(
  {
    backgroundLoading: "backgroundLoading",
  },
  NoDevicesPageCommercial
);



// WEBPACK FOOTER //
// ./src/components/Commercial/NoDevicesPageCommercial.jsx